"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-two/sections/doctorSection.tsx */

import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type DoctorSection36FadeInUpsItem = {
    key: Key | null | undefined;
    /** Detected variants: "/Templates/Doccure/img/doctors/general-01.jpg" | "/Templates/Doccure/img/doctors/general-02.jpg" | "/Templates/Doccure/img/doctors/general-03.jpg" | "/Templates/Doccure/img/doctors/general-04.jpg" */
    src: string;
    /** Detected variants: "Los Angeles, CA" | "Austin, TX" | "Newyork, USA" | "Waipahu, HI" */
    p0Text: ReactNode;
    /** Detected variants: "Dr. Hattie Driskell" | "Dr. Calvin Haley" | "Dr. Lisa Labonte" | "Dr. James Davidson" */
    link0Text: ReactNode;
    /** Detected variants: "Orthopedic" | "Dentist" | "Neurologist" | "Immunologist" */
    p0P0Text: ReactNode;
    /** Detected variants: "col-xl-3 col-md-6 wow fadeInUp" */
    className?: string;
    /** Detected variants: "0.2s" */
    dataWowDelay?: string;
    /** Detected variants: "1s" */
    dataWowDuration?: string;
    /** Detected variants: "doctor-item-two" */
    div0ClassName?: string;
    /** Detected variants: "doctor-image" */
    div0ClassName2?: string;
    /** Detected variants: "all_routes.doctorProfile1" */
    href?: string;
    /** Detected variants: "doctor" */
    alt?: string;
    /** Detected variants: "img-fluid" */
    imageWithBasePath0ClassName?: string;
    /** Detected variants: "doctor-content" */
    div1ClassName?: string;
    /** Detected variants: "available-info" */
    div0ClassName3?: string;
    /** Detected variants: "isax isax-location me-1" */
    i0ClassName?: string;
    /** Detected variants: "Available" */
    span0Text?: ReactNode;
    /** Detected variants: "badge bg-success" */
    span0ClassName?: string;
    /** Detected variants: "fa-solid fa-circle fs-5 me-1" */
    i0ClassName2?: string;
    /** Detected variants: "custom-title" */
    h30ClassName?: string;
    /** Detected variants: "all_routes.doctorProfile1" */
    link0Href?: string;
    /** Detected variants: "Book Now" */
    link0Link0Text?: ReactNode;
    /** Detected variants: "btn btn-md btn-light w-100" */
    link0ClassName?: string;
    /** Detected variants: "all_routes.booking" */
    link0Href2?: string;
    /** Detected variants: "isax isax-calendar-1 me-2" */
    i0ClassName3?: string;
    /** Detected variants: "speciality" */
    p0ClassName?: string;
};
export type HomeTwoDoctorSectionGeneratedProps = {
    divDiv0Div0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: DoctorSection36FadeInUpsItem) => Partial<ComponentProps<typeof SmartLink>>);
    divDiv0Div0Link0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: DoctorSection36FadeInUpsItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    divDiv0Div1H30H3Props?: Partial<ComponentProps<"h3">> | ((item: DoctorSection36FadeInUpsItem) => Partial<ComponentProps<"h3">>);
    divDiv0Div1H30Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: DoctorSection36FadeInUpsItem) => Partial<ComponentProps<typeof SmartLink>>);
    divDiv0Div1Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: DoctorSection36FadeInUpsItem) => Partial<ComponentProps<typeof SmartLink>>);
    /** Default: "Our Team" */
    sectionDiv0Div0Div0DivText?: ReactNode;
    /** Default: "icon" */
    sectionDiv0Div0Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/icons/section-icon.svg" */
    sectionDiv0Div0Div0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div0Div0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div0Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "Top Specialists" */
    sectionDiv0Div0H20H2Text?: ReactNode;
    sectionDiv0Div0H20H2Visible?: boolean;
    sectionDiv0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "Dedicated to Your Care" */
    sectionDiv0Div0H20Span0SpanText?: ReactNode;
    sectionDiv0Div1ClassName?: string;
    /** Default: "bg" */
    sectionImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/doctor-bg-01.png" */
    sectionImageWithBasePath0ImageSrc?: string;
    sectionImageWithBasePath0ImageVisible?: boolean;
    sectionImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "bg" */
    sectionImageWithBasePath1ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/about-bg.png" */
    sectionImageWithBasePath1ImageSrc?: string;
    sectionImageWithBasePath1ImageVisible?: boolean;
    sectionImageWithBasePath1ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    doctorSection36FadeInUps: DoctorSection36FadeInUpsItem[];
    doctorSection36FadeInUpsItemWrapper?: (item: DoctorSection36FadeInUpsItem, content: ReactNode) => ReactNode;
    doctorSection36FadeInUpsRenderer?: (defaultNode: ReactNode) => ReactNode;
    doctorSection36FadeInUpsLinkVisible?: boolean;
    doctorSection36FadeInUpsLinkRenderer?: (item: DoctorSection36FadeInUpsItem, defaultNode: ReactNode) => ReactNode;
    doctorSection36FadeInUpsImageVisible?: boolean;
    doctorSection36FadeInUpsImageRenderer?: (item: DoctorSection36FadeInUpsItem, defaultNode: ReactNode) => ReactNode;
    doctorSection36FadeInUpsH3Visible?: boolean;
    doctorSection36FadeInUpsH3Renderer?: (item: DoctorSection36FadeInUpsItem, defaultNode: ReactNode) => ReactNode;
    doctorSection36FadeInUpsLinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: DoctorSection36FadeInUpsItem) => Partial<ComponentProps<typeof SmartLink>>);
    doctorSection36FadeInUpsImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: DoctorSection36FadeInUpsItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    doctorSection36FadeInUpsH3Props?: Partial<ComponentProps<"h3">> | ((item: DoctorSection36FadeInUpsItem) => Partial<ComponentProps<"h3">>);
};

const HomeTwoDoctorSectionGenerated: FC<HomeTwoDoctorSectionGeneratedProps> = ({
    sectionDiv0Div0Div0DivText = "Our Team",
    sectionDiv0Div0Div0ImageWithBasePath0ImageAlt = "icon",
    sectionDiv0Div0Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/icons/section-icon.svg",
    sectionDiv0Div0Div0ImageWithBasePath0ImageVisible,
    sectionDiv0Div0Div0ImageWithBasePath0ImageRenderer,
    sectionDiv0Div0Div0ImageWithBasePath0ImageProps,
    sectionDiv0Div0H20H2Text = "Top Specialists",
    sectionDiv0Div0H20H2Visible,
    sectionDiv0Div0H20H2Renderer,
    sectionDiv0Div0H20H2Props,
    sectionDiv0Div0H20Span0SpanText = "Dedicated to Your Care",
    sectionImageWithBasePath0ImageAlt = "bg",
    sectionImageWithBasePath0ImageSrc = "/Templates/Doccure/img/bg/doctor-bg-01.png",
    sectionImageWithBasePath0ImageVisible,
    sectionImageWithBasePath0ImageRenderer,
    sectionImageWithBasePath0ImageProps,
    sectionImageWithBasePath1ImageAlt = "bg",
    sectionImageWithBasePath1ImageSrc = "/Templates/Doccure/img/bg/about-bg.png",
    sectionImageWithBasePath1ImageVisible,
    sectionImageWithBasePath1ImageRenderer,
    sectionImageWithBasePath1ImageProps,
    divDiv0Div0Link0ImageWithBasePath0ImageProps,
    divDiv0Div0Link0LinkProps,
    divDiv0Div1H30H3Props,
    divDiv0Div1H30Link0LinkProps,
    divDiv0Div1Link0LinkProps,
    sectionDiv0Div1ClassName,
    doctorSection36FadeInUps,
    doctorSection36FadeInUpsItemWrapper,
    doctorSection36FadeInUpsRenderer,
    doctorSection36FadeInUpsLinkVisible,
    doctorSection36FadeInUpsLinkRenderer,
    doctorSection36FadeInUpsImageVisible,
    doctorSection36FadeInUpsImageRenderer,
    doctorSection36FadeInUpsH3Visible,
    doctorSection36FadeInUpsH3Renderer,
    doctorSection36FadeInUpsLinkProps,
    doctorSection36FadeInUpsImageProps,
    doctorSection36FadeInUpsH3Props,
}) => {
    return (
        <section className="section doctor-section-two">
            <div className="container">
                <div className="section-header section-header-two">
                    <div className="section-sub-title">
                        {renderNode(sectionDiv0Div0Div0ImageWithBasePath0ImageVisible, sectionDiv0Div0Div0ImageWithBasePath0ImageRenderer, (
                            <SmartImage src={sectionDiv0Div0Div0ImageWithBasePath0ImageSrc} alt={sectionDiv0Div0Div0ImageWithBasePath0ImageAlt} {...(sectionDiv0Div0Div0ImageWithBasePath0ImageProps ?? {})} />
                        ))}
                        {sectionDiv0Div0Div0DivText}
                    </div>
                    {renderNode(sectionDiv0Div0H20H2Visible, sectionDiv0Div0H20H2Renderer, (
                        <h2 className="section-title mb-0" {...(sectionDiv0Div0H20H2Props ?? {})}>
                            {sectionDiv0Div0H20H2Text}
                            <span>{sectionDiv0Div0H20Span0SpanText}</span>
                        </h2>
                    ))}
                </div>
                <div className={sectionDiv0Div1ClassName ?? "row g-4"}>
                    {renderCollectionNode(
                        doctorSection36FadeInUps,
                        (item: DoctorSection36FadeInUpsItem) => (
                            <div className={item.className ?? "col-xl-3 col-md-6 wow fadeInUp"} data-wow-delay={item.dataWowDelay ?? "0.2s"} data-wow-duration={item.dataWowDuration ?? "1s"} key={item.key}>
                                <div className={item.div0ClassName ?? "doctor-item-two"}>
                                    <div className={item.div0ClassName2 ?? "doctor-image"}>
                                        {renderItemNode(doctorSection36FadeInUpsLinkVisible, doctorSection36FadeInUpsLinkRenderer, item, (
                                            <SmartLink href={item.href ?? "all_routes.doctorProfile1"} {...(typeof doctorSection36FadeInUpsLinkProps === "function" ? doctorSection36FadeInUpsLinkProps(item) : (doctorSection36FadeInUpsLinkProps ?? {}))} {...(typeof divDiv0Div0Link0LinkProps === "function" ? divDiv0Div0Link0LinkProps(item) : (divDiv0Div0Link0LinkProps ?? {}))}>
                                                {renderItemNode(doctorSection36FadeInUpsImageVisible, doctorSection36FadeInUpsImageRenderer, item, (
                                                    <SmartImage className={item.imageWithBasePath0ClassName ?? "img-fluid"} alt={item.alt ?? "doctor"} src={item.src} {...(typeof doctorSection36FadeInUpsImageProps === "function" ? doctorSection36FadeInUpsImageProps(item) : (doctorSection36FadeInUpsImageProps ?? {}))} {...(typeof divDiv0Div0Link0ImageWithBasePath0ImageProps === "function" ? divDiv0Div0Link0ImageWithBasePath0ImageProps(item) : (divDiv0Div0Link0ImageWithBasePath0ImageProps ?? {}))} />
                                                ))}
                                            </SmartLink>
                                        ))}
                                    </div>
                                    <div className={item.div1ClassName ?? "doctor-content"}>
                                        {renderItemNode(doctorSection36FadeInUpsH3Visible, doctorSection36FadeInUpsH3Renderer, item, (
                                            <h3 className={item.h30ClassName ?? "custom-title"} {...(typeof doctorSection36FadeInUpsH3Props === "function" ? doctorSection36FadeInUpsH3Props(item) : (doctorSection36FadeInUpsH3Props ?? {}))} {...(typeof divDiv0Div1H30H3Props === "function" ? divDiv0Div1H30H3Props(item) : (divDiv0Div1H30H3Props ?? {}))}>
                                                {renderItemNode(doctorSection36FadeInUpsLinkVisible, doctorSection36FadeInUpsLinkRenderer, item, (
                                                    <SmartLink href={item.link0Href ?? "all_routes.doctorProfile1"} {...(typeof doctorSection36FadeInUpsLinkProps === "function" ? doctorSection36FadeInUpsLinkProps(item) : (doctorSection36FadeInUpsLinkProps ?? {}))} {...(typeof divDiv0Div1H30Link0LinkProps === "function" ? divDiv0Div1H30Link0LinkProps(item) : (divDiv0Div1H30Link0LinkProps ?? {}))}>{item.link0Text}</SmartLink>
                                                ))}
                                            </h3>
                                        ))}
                                        <p className={item.p0ClassName ?? "speciality"}>{item.p0P0Text}</p>
                                        <div className={item.div0ClassName3 ?? "available-info"}>
                                            <p>
                                                <i className={item.i0ClassName ?? "isax isax-location me-1"} />
                                                {item.p0Text}
                                            </p>
                                            <span className={item.span0ClassName ?? "badge bg-success"}>
                                                <i className={item.i0ClassName2 ?? "fa-solid fa-circle fs-5 me-1"} />
                                                {item.span0Text ?? "Available"}
                                            </span>
                                        </div>
                                        {renderItemNode(doctorSection36FadeInUpsLinkVisible, doctorSection36FadeInUpsLinkRenderer, item, (
                                            <SmartLink href={item.link0Href2 ?? "all_routes.booking"} className={item.link0ClassName ?? "btn btn-md btn-light w-100"} {...(typeof doctorSection36FadeInUpsLinkProps === "function" ? doctorSection36FadeInUpsLinkProps(item) : (doctorSection36FadeInUpsLinkProps ?? {}))} {...(typeof divDiv0Div1Link0LinkProps === "function" ? divDiv0Div1Link0LinkProps(item) : (divDiv0Div1Link0LinkProps ?? {}))}>
                                                <i className={item.i0ClassName3 ?? "isax isax-calendar-1 me-2"} />
                                                {item.link0Link0Text ?? "Book Now"}
                                            </SmartLink>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        ),
                        doctorSection36FadeInUpsItemWrapper,
                        doctorSection36FadeInUpsRenderer
                    )}
                </div>
            </div>
            {renderNode(sectionImageWithBasePath0ImageVisible, sectionImageWithBasePath0ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath0ImageSrc} alt={sectionImageWithBasePath0ImageAlt} className="img-fluid doctor-bg-01" {...(sectionImageWithBasePath0ImageProps ?? {})} />
            ))}
            {renderNode(sectionImageWithBasePath1ImageVisible, sectionImageWithBasePath1ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath1ImageSrc} alt={sectionImageWithBasePath1ImageAlt} className="img-fluid doctor-bg-02" {...(sectionImageWithBasePath1ImageProps ?? {})} />
            ))}
        </section>
    );
};

export default HomeTwoDoctorSectionGenerated;
